import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import {
  Drawer,
  List,
  ListItemText,
  ListItemButton,
  Collapse,
  IconButton,
  Box,
  Typography,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import api from "../../../../services/api/api";

import SearchIcon from "@mui/icons-material/Search";


const DrawerMenu = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState({});
  const [publicacoesItens, setPublicacoesItens] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchPublicacoesCategorias = async () => {
      try {
        const response = await api.get("api/categories");
        if (response.data) {
          setPublicacoesItens(response.data);
        }
      } catch (error) {
        console.error("Erro ao buscar categorias de publicações:", error.message);
      }
    };
    fetchPublicacoesCategorias();
  }, []);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const toggleSubMenu = (menu) => {
    setOpenSubMenu((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  const handleNavigation = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const handleSearchSubmit = () => {
    if (searchQuery.trim()) {
      navigate(`/search-results?q=${searchQuery}`);
      setDrawerOpen(false);
    }
  };

  const vereadoresItens = [
    { label: "Cris Azevedo", to: "/vereadores/crisazevedo" },
    { label: "Edilmo Lira", to: "/vereadores/edilmolira" },
    { label: "Erivan Elias da Silva", to: "/vereadores/erivanelias" },
    { label: "Jailson Mendonça da Silva", to: "/vereadores/jailsonmendonca" },
    { label: "Janaína Patrícia Bezerra da Silva", to: "/vereadores/janainabezerra" },
    { label: "Leandro Euclides Guedes da Costa", to: "/vereadores/leandroeuclides" },
    { label: "Marcia Costa Araujo Gomes", to: "/vereadores/marciacosta" },
    { label: "Ovídio de Aquino e Silva Neto", to: "/vereadores/ovidiodeaquino" },
    { label: "Wagner Ferreira Gonçalves", to: "/vereadores/wagnerferreira" },
  ];

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: "space-between", gap: "50px" }}>
        <IconButton onClick={toggleDrawer(true)} sx={{ display: { xs: "block", md: "none", color: theme.palette.primary.text } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MenuIcon />
            <Typography>Menu</Typography>
          </Box>
        </IconButton>
        <TextField
          width="100%"
          variant="outlined"
          placeholder="Pesquisar..."
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Button onClick={handleSearchSubmit} sx={{ minWidth: "50px", padding: "7px 8px", background: theme.palette.primary.text }}>
                  <SearchIcon sx={{ color: theme.palette.primary.main }} /> {/* Ícone de pesquisa preto */}
                </Button>
              </InputAdornment>
            ),
          }}

          sx={{
            display: { xs: "block", md: "none" },
            width: "100%",
            borderRadius: "4px",
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "white" },
              "&.Mui-focused fieldset": { borderColor: "white" },
            },
            "& .MuiInputBase-input": {
              color: "white", // Cor do texto dentro do input
            },
            "& .MuiInputAdornment-root": {
              color: "white", // Cor do ícone
            },
            "& .MuiInputBase-root":{
                  padding: 0
                },
          }}
        />

      </Box>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250 }} role="presentation">
          <List>

            <ListItemButton onClick={() => handleNavigation("/")}>
              <ListItemText sx={{ textTransform: "uppercase" }} primary="Inicio" />
            </ListItemButton>

            <ListItemButton onClick={() => toggleSubMenu("aCamara")}>
              <ListItemText sx={{ textTransform: "uppercase" }} primary="A Câmara" />
              {openSubMenu["aCamara"] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openSubMenu["aCamara"]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleNavigation("mesadiretora")}>
                  <ListItemText sx={{ textTransform: "uppercase" }} primary="Mesa diretora" />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => handleNavigation("institucional")}>
                  <ListItemText sx={{ textTransform: "uppercase" }} primary="Institucional" />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton onClick={() => handleNavigation("noticias")}>
              <ListItemText sx={{ textTransform: "uppercase" }} primary="Notícias" />
            </ListItemButton>

            <ListItemButton
              onClick={() => window.open("https://cmserracaiadarn.transparencia.topsolutionsrn.com.br/", "_blank")}
            >
              <ListItemText sx={{ textTransform: "uppercase" }} primary="Portal da Transparência" />
            </ListItemButton>

            <ListItemButton onClick={() => toggleSubMenu("publicacoes")}>
              <ListItemText sx={{ textTransform: "uppercase" }} primary="Publicações" />
              {openSubMenu["publicacoes"] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openSubMenu["publicacoes"]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {publicacoesItens.map((publicacao) => (
                  <ListItemButton key={`${publicacao.id}-${publicacao.name}`} sx={{ pl: 4 }} onClick={() => handleNavigation(`/publicacoes/${publicacao.name}`)}>
                    <ListItemText sx={{ textTransform: "uppercase" }} primary={publicacao.name} />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>


            <ListItemButton onClick={() => toggleSubMenu("vereadores")}>
              <ListItemText sx={{ textTransform: "uppercase" }} primary="Vereadores" />
              {openSubMenu["vereadores"] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openSubMenu["vereadores"]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {vereadoresItens.map((vereador) => (
                  <ListItemButton key={vereador.to} sx={{ pl: 4 }} onClick={() => handleNavigation(vereador.to)}>
                    <ListItemText sx={{ textTransform: "uppercase" }} primary={vereador.label} />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>

            <ListItemButton sx={{ textTransform: "uppercase" }} onClick={() => handleNavigation("faleconosco")}>
              <ListItemText primary="ouvidoria" />
            </ListItemButton>

          </List>
        </Box>
      </Drawer>
    </div>
  );
};

export default DrawerMenu;
